<script>
    import {onMount} from 'svelte';

    export let ingredients = [];
    export let description;
    export let name;
    export let price = '9.00';

    let price_rotation = Math.floor((Math.random() * (Math.abs(-15) + Math.abs(15))) - Math.abs(-15));

    let windowHeight;
    let windowWidth;

    function computeCardWith(){
        if(windowWidth < 1050 && windowWidth > 768){
            return '50'
        }else if (windowWidth < 768) {
            return '100'
        }else{
            return '30'
        }
    }
</script>

<style>
    .menu-item-card {
        text-align: center;
        display: inline-block;
        margin: 10px 0;
    }
    .menu-item-name {
        display: inline-block;
        margin: 0 10px;
        font-family: 'Permanent Marker', cursive;
        font-size: 2em;
    }
    .menu-item-price {
        display: inline-block;
        font-size: 1.5em;
        color: #52AF5E;
    }
    .menu-item-description {
        font-family: 'Indie Flower', cursive;
        padding: 5px;
    }
</style>

<svelte:window bind:innerHeight={windowHeight} bind:innerWidth={windowWidth} />

{#if windowWidth < 1050 && windowWidth > 768}
    <div class="menu-item-card" style="width: 50%">
        <div>
            <div class="menu-item-name">{name}</div>
            <div class="menu-item-price" style="transform: rotate({price_rotation}deg)">{price}€</div>
        </div>
        <div class="menu-item-description" style="font-size: 1.2em">
            {description}
        </div>
    </div>
{:else if windowWidth < 768}
    <div class="menu-item-card" style="width: 100%">
        <div>
        <div class="menu-item-name">{name}</div>
        <div class="menu-item-price" style="transform: rotate({price_rotation}deg)">{price}€</div>
    </div>
        <div class="menu-item-description" style="font-size: 1.5em">
            {description}
        </div>
    </div>
{:else}
    <div class="menu-item-card" style="width: 33%">
        <div>
            <div class="menu-item-name">{name}</div>
            <div class="menu-item-price" style="transform: rotate({price_rotation}deg)">{price}€</div>
        </div>
        <div class="menu-item-description">
            {description}
        </div>
    </div>
{/if}